import { Order } from '@/coreDomainsModule/entities/order';

/**
 * リマインドメール関連のドメインサービス
 */
export class ReminderMailService {
  /**
   * メールが設定済みかどうかを判定する
   * @param order - 発注情報
   * @returns メールが設定済みの場合true
   */
  static isReminderMailConfigured(order: Order): boolean {
    if (order == null) return false;
    return order.reminderMailDataId !== null && order.reminderMailDataId !== '';
  }

  /**
   * reminderMailDataIdからメール設定済み状態を判定する
   * @param reminderMailDataId - リマインドメールデータID
   * @returns メールが設定済みの場合true
   */
  static hasReminderMailSetting(reminderMailDataId: string | null): boolean {
    return reminderMailDataId !== null && reminderMailDataId !== '';
  }
}
